<template>
  <div class="summary-item">
    <div class="summary-label">{{ label }}</div>
    <div class="summary-value">{{ value || '-' }}</div>
  </div>
</template>

<script>
export default {
  name: "SummaryItem",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
};
</script>

<style scoped>
.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px dashed rgba(38, 50, 56, 0.2);
}

.summary-label {
  font-weight: 600;
  color: #283593;
}

.summary-value {
  font-weight: 500;
  color: #1a237e;
}

.summary-item:last-of-type {
  border-bottom: none;
}
</style>
